import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useAdminJob(service, queueId, jobId) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  async function fetchAdminJob(isRefresh = false) {
    if (!isRefresh) {
      setLoading(true);
    }

    const { response, data } = await API.admin.fetchJob(token, service, queueId, jobId);

    if (response.ok) {
      setResult(data);
      setError(null);
    } else {
      setResult(null);
      setError(data.message);
    }

    setLoading(false);
  }

  useEffect(() => {
    fetchAdminJob();
  }, [token, service, queueId, jobId]);

  return {
    loading,
    error,
    job: result,
    refresh: () => fetchAdminJob(true),
  }
}
